<script lang="ts" setup generic="T extends ProductSearchGolf | GolfLite">
  import type { Nullable } from '~/core/types'
  import type { ProductSearchGolf } from '~/core/types/products'
  import type { GolfLite } from '~/core/types/shared'

  import GolfCardWrapper from './GolfCardWrapper.vue'

  type Props = {
    golfs: T[]
    selectedGolfId?: Nullable<number>
  }
  const props = defineProps<Props>()
  const scrollElement = useTemplateRef('scroll-h')
  const { t } = useI18n()
  const golfIndex = computed(() => {
    const index = props.golfs.findIndex(({ id }) => id === props.selectedGolfId)
    return index >= 0 ? `${index}` : '-'
  })

  watch(() => props.selectedGolfId, (val) => {
    scroll(val ?? null)
  })

  function scroll(val: Nullable<number>) {
    if (!val) {
      return
    }

    const selectedElement: Nullable<HTMLDivElement> = scrollElement.value?.querySelector(`#golf-${val}`) ?? null
    if (!selectedElement) {
      return
    }
    scrollElement.value?.scrollTo({
      left: selectedElement.offsetLeft - 24,
      behavior: 'smooth',
    })
  }

</script>
<template>
  <div class="c-results-resume-list">
    <div>
      <p class="amount">
        <span @click="() => scroll(props.selectedGolfId ?? null)">
          {{ golfIndex }}/{{ t("products.results", golfs.length) }}
        </span>
      </p>
    </div>
    <div
      ref="scroll-h"
      class="scroll-h"
    >
      <div class="body">
        <Paper
          v-for="golf in golfs"
          :id="`golf-${golf.id}`"
          :key="golf.id"
        >
          <GolfCardWrapper
            :golf="golf"
            is-home
            display-mobile
          />
        </Paper>
      </div>
    </div>
  </div>
</template>
<style scoped>

.c-results-resume-list {
  display: flex;
  overflow: hidden;
  width: 100%;
  flex: 0 0 55%;
  flex-direction: column;
  background-color: white;

  .amount {
    padding: 1em 1.5em 0;

    span {
      color: var(--color-secondary);
      font-family: Open-Sans, sans-serif;
      font-size: 1.125em;
      font-weight: bold;
      opacity: 0.4;
    }
  }

  .scroll-h {
    display: flex;
    flex: 0 1 auto;
    flex-direction: row;
    padding-bottom: 1em;
    overflow-x: auto;

    .body {
      display: flex;
      flex: 0 0 auto;
      padding: 1em 0.75em;

      .c-paper {
        width: 220px;
        margin: 0 0.75em;
      }
    }
  }

  @media screen and (width >= 1024px) {
    flex: 0 0 50%;

    .scroll-h {
      flex: 1 0 auto;

      .body {
        .c-paper {
          max-width: 320px;
        }
      }
    }
  }
}
</style>
